import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["props"]
const _hoisted_4 = ["props"]
const _hoisted_5 = { class: "box-row items-center" }
const _hoisted_6 = { class: "header" }
const _hoisted_7 = { class: "content q-pa-sm ellipsis" }
const _hoisted_8 = { class: "ellipsis text-body2" }
const _hoisted_9 = ["props"]
const _hoisted_10 = { class: "text-body2" }
const _hoisted_11 = ["props"]
const _hoisted_12 = {
  key: 0,
  class: "flex justify-start"
}
const _hoisted_13 = {
  class: "text-caption text-weight-bold text-uppercase",
  style: {"font-size":"10px !important","letter-spacing":"0.115em"}
}
const _hoisted_14 = ["props"]
const _hoisted_15 = { class: "text-body2" }
const _hoisted_16 = {
  key: 0,
  class: "text-body3 text-grey-7 ellipsis"
}
const _hoisted_17 = ["props"]
const _hoisted_18 = { class: "text-body2" }
const _hoisted_19 = ["props"]
const _hoisted_20 = ["onClick"]

import { formatTimeAgo } from "@vueuse/core";
  import { computed, PropType, ref } from "vue";
  import { useRouter } from "vue-router";
  import { useSettingsStore } from "src/stores/settings-store";
  import { useAuthStore } from "../../../stores/auth-store";
  import { useDifferenceInMinutes, useCapitalise, useDifferenceInDays, useMapQuickQuoteToLoanApplication } from "src/functions";
  import { LoanDecisionType_Enum, LoanStatusType_Enum } from "src/types/enums/index";
  import { Customer, LoanApplication, Vehicle } from "src/types/loan-application/index";
  import { QuickQuote } from "src/types/quote/index";
  import ApplicationOverview from "src/components/customer/proposal/ApplicationOverview.vue";
  import { QTableColumn } from "quasar";
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ListView',
  props: {
    applications: {
      type: Array as PropType<LoanApplication[]>,
      default: []
    },
    quickQuotes: {
      type: Array as PropType<LoanApplication[]>,
      default: []
    }
  },
  setup(__props) {

  const settingsStore = useSettingsStore();
  const authStore = useAuthStore();

  const router = useRouter();

  const props = __props

  const isMobile = computed(() => settingsStore.isMobile);

  function sanitiseName(name: string) {
    if (name === "Carfinance.Application.Form.Prototype") {
      return "Customer application";
    }
    return name;
  }

  function dealerName(app: LoanApplication) {
    if (!authStore.selectedDealers) {
      return null;
    }

    const d = authStore.selectedDealers.find(d => d.affiliateUserId === Number(app.affiliateUserId));

    if (!d) {
      return null;
    }

    const split = d.name.replace("t/a", "T/A").split(" T/A ");

    return split.length === 1 ? split[0] : split[1];
  }

  const visibleColumns = ref(['customer', 'vrm', 'vehicle', 'status', 'decision', 'createdBy', 'lastUpdated', 'options'])
  const columns = computed(() => [
    { name: 'application', label: '', field: 'application' },
    { name: 'customer', label: 'Customer', field: 'customer', align: 'left', sortable: true, sort: (a: Customer, b: Customer) => a.lastName < b.lastName ? -1 : 1 },
    { name: 'vrm', label: 'VRM', field: 'vrm', align: 'left' },
    { name: 'vehicle', label: 'Vehicle', field: 'vehicle', align: 'left'  },
    { name: 'status', label: 'Status', field: 'status', align: 'left', sortable: true, sort: (a: { name: string, id: number }, b: { name: string, id: number }) => a.name < b.name ? -1 : 1  },
    {
      name: 'decision', label: 'Decision', field: 'decision', align: 'left', sortable: true, sort: (a: { name: string, id: number }, b: { name: string, id: number }) => a.name < b.name ? -1 : 1
    },
    { name: 'createdBy', label: 'Created by', field: 'createdBy', align: 'left', sortable: true },
    { name: 'lastUpdated', label: 'Last updated', field: 'lastUpdated', align: 'left', sortable: true, sort: (a: Date, b: Date) => b.getTime() - b.getTime() ? -1 : 1 },
    { name: 'options', label: '', field: 'options', align: 'right' }
  ] as QTableColumn[])

  const rows = computed(() => {
    const rs = [] as {
      application: LoanApplication,
      customer: Customer | null,
      vrm: string,
      vehicle: Vehicle,
      status: { id: number, name: string } | null,
      decision: { name: string, class: string} | null,
      createdBy: string,
      lastUpdated: Date
    }[]

    for (const a of props.applications) {
      const de = decisionStatus(a);

      rs.push({
        application: a,
        customer: a.customer,
        vehicle: a.vehicle,
        vrm: a.vehicle ? a.vehicle.vehicleRegistration : '',
        status: { name: LoanStatusType_Enum[a.state], id: a.state },
        decision: de ? { name: de.label, class: de.colour } : null,
        createdBy: a.createdBy,
        lastUpdated: new Date(a.lastUpdated)
      })
    }

    for (const a of props.quickQuotes) {

      rs.push({
        application: a,
        customer: a.customer,
        vehicle: a.vehicle,
        vrm: a.vehicle ? a.vehicle.vehicleRegistration : '',
        status: { name: "Quick Quote", id: -1 },
        decision: null,
        createdBy: a.createdBy,
        lastUpdated: new Date(a.created)
      })
    }

    return rs.sort((a, b) => new Date(a.lastUpdated).getTime() < new Date(b.lastUpdated).getTime() ? 1 : -1);
  })

  function imgSrc(veh: Vehicle) {
    if (!veh) {
      return require("assets/img/no-image.png");
    }
    if (veh.image) {
      return veh.image
    }
    if (veh.vehicleId) {
      return `https://res.cloudinary.com/carfinance247-co-uk/image/upload/t_car_search_detail/v1/${veh.vehicleId}/1.webp`
    }
    return require("assets/img/no-image.png");
  }

  function vehicleValid(application: LoanApplication) {

    if ([
      LoanStatusType_Enum["NTU Rate Too High"],
      LoanStatusType_Enum["NTU Lost To Competitor"],
      LoanStatusType_Enum["NTU Outside Criteria"],
      LoanStatusType_Enum["NTU Other"],
    ].includes(application.state)) {
      return 0;
    }

    if (!application || !application.vehicle || application.isQuickQuote) {
      return 0;
    }

    if (!application || !application.proposals || application.proposals.length === 0) {
      return 0;
    }

    if (application.vehicle && application.vehicle.cannotPrice) {
      return 2;
    }

    return 3;
  }

  function decisionStatus(application: LoanApplication) {

    // Complete
    if (application.state === LoanStatusType_Enum.Completed) {
      return {
        label: "Completed",
        colour: "bg-positive text-white"
      };
    }

    // NTU 
    if ([
      LoanStatusType_Enum["NTU Rate Too High"],
      LoanStatusType_Enum["NTU Lost To Competitor"],
      LoanStatusType_Enum["NTU Outside Criteria"],
      LoanStatusType_Enum["NTU Other"]
    ].includes(application.state)) {
      return {
        label: `${LoanStatusType_Enum[application.state]}`,
        colour: "bg-warning text-dark"
      };
    }

    // Expired
    if (useDifferenceInDays(application.created, new Date()) > 45) {
      return {
        label: "Proposals Expired",
        colour: "bg-warning text-dark"
      };
    }
    if (application.proposals && application.proposals.length > 0) {
      // Approved / Vehicle Failed
      if (application.proposals.find(p => p.loanProposalStatus && p.loanProposalStatus.toString() === 'Accepted')) {
        const vv = vehicleValid(application);
        return {
          label: [3, 0].includes(vv) ? "Approved" : "Failed Vehicle Rule",
          colour: [3, 0].includes(vv) ? "bg-positive text-white" : "bg-warning text-dark"
        }
      }

      // Provisional Approval / Vehicle Failed
      if (application.proposals.find(p => p.loanProposalStatus && p.loanProposalStatus.toString() === 'ProvisionalAcceptance' && (!p.customerRuleResults || (p.customerRuleResults && p.customerRuleResults.find(r => r.resultType === "FixedDecline"))))) {
        const vv = vehicleValid(application);
        return {
          label: [3, 0].includes(vv) ? "Approved (Predicted)" : "Failed Vehicle Rule",
          colour: [3, 0].includes(vv) ? "bg-positive  text-white" : "bg-warning text-dark"
        }
      }

      // Processing
      if (application.proposals.find(p => p.loanProposalStatus && p.loanProposalStatus.toString() === 'Processing')) {
        return {
          label: "Awaiting Decision",
          colour: "bg-warning"
        }
      }

      // Failes Customer Rules
      if (application.proposals.find(p => (p.customerRuleResults && p.customerRuleResults.find(r => r.resultType === 'FixedDecline')) || (p.loanProposalStatus && p.loanProposalStatus.toString() === 'FailedSendRules'))) {
        return {
          label: "Failed Customer Rules",
          colour: "bg-warning text-dark"
        }
      }

      // Declined
      if (application.proposals.find(p => p.loanProposalStatus && p.loanProposalStatus.toString() === 'Declined')) {
        return {
          label: "Declined",
          colour: "bg-negative text-white"
        }
      }
    }
    else {
      // App just created
      if (useDifferenceInMinutes(new Date(application.created), new Date()) < 15) {
        return {
          label: "Awaiting Decision",
          colour: "bg-warning text-dark"
        };
      }


      if (!application.proposals || !application.proposals.length) {
        return null
      }
    }
  }

  function viewApplication(app: LoanApplication) {
    if (!app.isQuickQuote) {
      router.push({ path: `/customer/${app.brokerReference}` });
    }
    else {
      router.push({ path: `/quick-quote/${app.quickQuoteId}` });
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_table = _resolveComponent("q-table")!
  const _directive_ripple = _resolveDirective("ripple")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_table, {
    flat: "",
    grid: isMobile.value,
    bordered: "",
    rows: rows.value,
    columns: columns.value,
    "row-key": "name",
    "hide-pagination": isMobile.value ? true : false,
    class: "full-height sticky-table",
    pagination: { rowsPerPage: isMobile.value ? 0 : 20},
    "visible-columns": visibleColumns.value
  }, {
    header: _withCtx((props) => [
      _createVNode(_component_q_tr, { props: props }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
            return (_openBlock(), _createBlock(_component_q_th, {
              key: col.name,
              props: props,
              class: "text-overline text-uppercase",
              style: {"font-weight":"700 !important"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(col.label), 1)
              ]),
              _: 2
            }, 1032, ["props"]))
          }), 128))
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    body: _withCtx((props) => [
      _createVNode(_component_q_tr, {
        props: props,
        clickable: "",
        class: "cursor-pointer",
        onClick: ($event: any) => (viewApplication(props.row.application))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_menu, { "context-menu": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_list, null, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    clickable: "",
                    onClick: ($event: any) => (viewApplication(props.row.application))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { side: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            name: "mdi-eye",
                            size: "xs"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createTextVNode(" View ")
                        ])),
                        _: 1,
                        __: [0]
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"])), [
                    [_directive_ripple],
                    [_directive_close_popup]
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_q_td, {
            key: "customer",
            props: props,
            class: _normalizeClass(["text-subtitle2", props.cols[0]['__thClass'].includes('sorted') ? 'brand-bg-highlight' : ''])
          }, {
            default: _withCtx(() => [
              (props.row.customer)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(useCapitalise)(props.row.customer.firstName)) + " " + _toDisplayString(_unref(useCapitalise)(props.row.customer.lastName)), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_2, " No customer provided "))
            ]),
            _: 2
          }, 1032, ["props", "class"]),
          _createElementVNode("td", {
            key: "vrm",
            props: props
          }, [
            _createVNode(_component_q_badge, {
              color: "reg-yellow",
              class: "text-reg text-dark text-subtitle3"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.vrm), 1)
              ]),
              _: 2
            }, 1024)
          ], 8, _hoisted_3),
          _createElementVNode("td", {
            key: "vehicle",
            props: props,
            style: {"max-width":"300px !important"}
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_q_avatar, { size: "52px" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_img, {
                      class: "full-height",
                      fit: "cover",
                      loading: "lazy",
                      src: imgSrc(props.row.vehicle)
                    }, {
                      error: _withCtx(() => [
                        _createVNode(_component_q_img, {
                          class: "full-height",
                          fit: "cover",
                          loading: "lazy",
                          src: require('assets/img/no-image.png')
                        }, null, 8, ["src"])
                      ]),
                      _: 2
                    }, 1032, ["src"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(props.row.vehicle.make) + " " + _toDisplayString(props.row.vehicle.model), 1)
              ])
            ])
          ], 8, _hoisted_4),
          _createElementVNode("td", {
            key: "status",
            props: props,
            class: _normalizeClass(props.cols[3]['__thClass'].includes('sorted') ? 'brand-bg-highlight' : '')
          }, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(props.row.status ? props.row.status.name : ''), 1)
          ], 10, _hoisted_9),
          _createElementVNode("td", {
            key: "decision",
            props: props,
            class: _normalizeClass(props.cols[4]['__thClass'].includes('sorted') ? 'brand-bg-highlight' : '')
          }, [
            (props.row.decision)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_q_badge, {
                    class: _normalizeClass(props.row.decision.class)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(props.row.decision.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["class"])
                ]))
              : _createCommentVNode("", true)
          ], 10, _hoisted_11),
          _createElementVNode("td", {
            key: "createdBy",
            props: props,
            class: _normalizeClass(props.cols[5]['__thClass'].includes('sorted') ? 'brand-bg-highlight' : '')
          }, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(sanitiseName(props.row.createdBy)), 1),
            (_unref(authStore).selectedDealers && _unref(authStore).selectedDealers.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(dealerName(props.row.application)), 1))
              : _createCommentVNode("", true)
          ], 10, _hoisted_14),
          _createElementVNode("td", {
            key: "lastUpdated",
            props: props,
            class: _normalizeClass(props.cols[6]['__thClass'].includes('sorted') ? 'brand-bg-highlight' : '')
          }, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(props.row.lastUpdated ? _unref(useCapitalise)(_unref(formatTimeAgo)(new Date(props.row.lastUpdated))) : ''), 1)
          ], 10, _hoisted_17),
          _createElementVNode("td", {
            key: "options",
            props: props
          }, null, 8, _hoisted_19)
        ]),
        _: 2
      }, 1032, ["props", "onClick"])
    ]),
    item: _withCtx((props) => [
      _createElementVNode("div", {
        class: "q-mb-md col-xs-12 col-sm-6 col-md-4 cursor-pointer",
        onClick: ($event: any) => (viewApplication(props.row.application))
      }, [
        _createVNode(ApplicationOverview, {
          application: props.row.application
        }, null, 8, ["application"])
      ], 8, _hoisted_20)
    ]),
    _: 1
  }, 8, ["grid", "rows", "columns", "hide-pagination", "pagination", "visible-columns"]))
}
}

})